/**
 * The various major z-index layers, adjust with caution and leave space between to add to later.
 */
export const Layers = {
    HeaderBackdrop: 90,
    Header: 100,
    ModalBackdrop: 990,
    Modal: 1000,
    Popup: 1001,
};
